<template>
  <div>
    <el-dialog title="新建赠送码"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               width="540px"
               @close="emitClose">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="110px">
        <el-form-item label="赠送码标题："
                      prop="task_title">
          <el-input v-model="dataForm.task_title"
                    maxlength="30"
                    show-word-limit
                    type="text"
                    placeholder="请输入赠送码标题"></el-input>
        </el-form-item>
        <el-form-item label="数量："
                      prop="generate_count">
          <el-input v-model="dataForm.generate_count"
                    type="Number"
                    placeholder="请输入赠送码数量（不大于1000）"></el-input>
        </el-form-item>

        <el-form-item label="有效时间："
                      prop="time">
          <el-date-picker v-model="dataForm.time"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']"
                          value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="赠送说明："
                      prop="task_description">
          <el-input v-model="dataForm.task_description"
                    maxlength="80"
                    show-word-limit
                    type="text"
                    placeholder="请输入赠送说明内容"></el-input>
        </el-form-item>
        <el-form-item label="赠送内容："
                      prop="ref_id">
          <span style="color: #409EFF;cursor: pointer;"
                @click="contentChoose()"
                v-if="products.length==0">点击选择</span>
          <el-tag type="success"
                  v-else>{{products[0].name}}</el-tag>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="emitClose">取 消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确 定</el-button>
      </div>
      <GoodsTabsChoose :visible="goodsChooseDialog"
                       type="single"
                       @close="goodsChooseDialog = false"
                       @submit="saveGoods"
                       :goods="products"
                       :chooseable="true" />
    </el-dialog>

  </div>
</template>

<script>
import { startProductCodeCreate } from '@/api/productExchange'
import GoodsTabsChoose from '@/components/dialog/product/GoodsTabsChoose'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GoodsTabsChoose,
  },
  data() {
    return {
      goodsChooseDialog: false,
      dataForm: {},
      products: [],
      dialogFormVisible: this.visible,
      rules: {
        task_title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        generate_count: [
          { required: true, message: '请输入数量', trigger: 'blur' },
        ],
        time: [
          {
            required: true,
            message: '请选择开始时间结束时间',
            trigger: 'change',
          },
        ],
        ref_id: [
          {
            required: true,
            message: '请选择商品',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.products.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  mounted() {},
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    saveGoods(val) {
      this.products[0] = val
    },
    contentChoose() {
      this.goodsChooseDialog = true
    },
    emitClose() {
      this.dataForm = {}
      this.products = []

      this.$emit('close')
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let data = {
            start_time: this.dataForm.time[0],
            end_time: this.dataForm.time[1],
            active_time_type: 1,
            product_id: this.products[0].id,
            generate_count: this.dataForm.generate_count,
            start_code_task_obj: {
              task_title: this.dataForm.task_title,
              task_description: this.dataForm.task_description,
            },
          }
          startProductCodeCreate(data).then((res) => {
            this.$message.success('创建成功')
            this.emitClose()
            this.$emit('sumbit')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;

  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
</style>